<template>
    <mu-breadcrumb>
        <mu-breadcrumb-item href="#">层</mu-breadcrumb-item>
        <mu-breadcrumb-item href="#">级</mu-breadcrumb-item>
        <mu-breadcrumb-item>结构</mu-breadcrumb-item>
    </mu-breadcrumb>
</template>
<script>
export default {
    name: 'breadcrumb'
}
</script>



// WEBPACK FOOTER //
// breadcrumb.vue?781ab356